import React from 'react';
import { Link } from 'react-router-dom';
import "../styles/Catering.css";

function Catering() {

    return (
        <div className="container-fluid catering-section-background my-5-5 py-5">
            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-6 catering-photo-container rounded">
                        <img src={require("../assets/photos/catering.webp")} className="catering-photo rounded img-hover-zoom img-shadow"></img>
                    </div>
                    <div className="col-12 col-md-6 catering-content d-flex flex-column justify-content-center">
                        <h3 className="fs-2 text-green-light">Catering</h3>
                        <hr className="divider py-0" />
                        <div className="catering-text">
                            <p>Długie doświadczenie i wykwalifikowana załoga to
                            gwarancja wyśmienitego menu, nienagannej aranżacji
                            stołów i przyjęcia ze smakiem i aromatem.
                            Zamów catering u Samych Swoich!
                            </p>
                            <p className='fw-bold'>Zamów catering u Samych Swoich!</p>
                            <Link to={'/kontakt'} className="btn btn-primary">Kontakt</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default Catering;